// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_56c954d4","outerContainer":"_8c7cb96e","secondaryToolbar":"c1a4967f","doorHangerRight":"_25dbfd2f","toolbarContainer":"e4f63a79","toolbarViewerMiddle":"bdb9bb4e","progressBar":"_056b7740","back-to-application":"_98b99ec4","root":"_71c52200"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientHealthboard/AddDataModal/index.styl
// module id = 5037
// module chunks = 39